import {
	ConstructionSiteStatus,
	ConstructionSiteStatusLabels,
	GFAStatus,
} from "@dune/types";
import { constructionSiteStatusStyles } from "@dune/utils";

export const ConstructionSiteStatusBadge = ({
	status,
	isSkipped,
}: { status: ConstructionSiteStatus | GFAStatus; isSkipped: boolean }) => {
	return (
		<span
			className={`px-2 py-1 rounded-full text-xs font-medium border ${constructionSiteStatusStyles[isSkipped ? "REFUSED" : status]}`}
		>
			{isSkipped ? "Sans suite" : ConstructionSiteStatusLabels[status]}
		</span>
	);
};
